import { createTheme } from '@mui/material/styles';
import '@fontsource/lexend-exa/300.css'

const theme = createTheme({
  typography: {
    fontFamily: '"Lexend Exa", sans-serif',
    fontWeightRegular: 400
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#3a4c17', // Default background color
          color: '#fff', // Default text color
          '&:hover': {
            backgroundColor: '#fff', // Background color on hover
            color: '#000000ff', // Text color on hover
          },
        },
      },
      defaultProps: {
        variant: 'contained', // Default variant for all buttons
      },
    },
  },
});

export default theme;
